import * as types from 'models/actionTypes'

const initialState = []

const toasts = (state = initialState, action) => {
    switch (action.type) {
        case types.SHOW_TOAST:
            return [
                ...state,
                {
                    toastType: action.toastType,
                    props: action.props,
                },
            ]
        case types.HIDE_TOAST: {
            const nextState = [...state]
            nextState.splice(action.index, 1)
            return nextState
        }
        default:
            return state
    }
}

export default toasts
